/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_High_Temperature_Return_Two_Way_ValveInputs */



/**
* | output |
* | --- |
* | "High-temperature return 2-way valve" |
*
* @param {Actuator_Type_High_Temperature_Return_Two_Way_ValveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_high_temperature_return_two_way_valve = /** @type {((inputs?: Actuator_Type_High_Temperature_Return_Two_Way_ValveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_High_Temperature_Return_Two_Way_ValveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("High-temperature return 2-way valve")
	return /** @type {LocalizedString} */ ("Vanne 2 voies retour haute température")
});